<template>
<div>
    <sidebar-item :link="{ name: 'CONFIGURAÇÕES', icon: 'fas fa-cogs text-info' }">
        <sidebar-item v-if="permissoes.permissaoRead" :link="{ name: 'PERMISSÕES', path: '/permissoes', icon:'fas fa-key' }" />
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarPermissao',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>

